import api from '.'

export const tillo = {
  getBrands (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/incentives/brands`, null, success, fail)
  },
  listIncentives (trialId, participantId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/participants/${participantId}/incentives`, null, success, fail)
  },
  issueIncentive (trialId, participantId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/participants/${participantId}/incentives`, data, success, fail)
  }
}
